import React, { Fragment as _, useContext } from 'react';
import { interactionContext } from './interactionContext';
import EditableBtn from '../EditableBtn';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { State } from 'store/store';
import { Block } from '@chameleoncreator/creator-app';
import { useSelector, useDispatch } from 'react-redux';
import { updateAssessmentAction } from 'actions/updateAssessmentAction';
import { Box } from 'theme-ui';

const FeedbackFailed = ({ children, ...props }) => {
  const context = useContext(interactionContext) as any;

  return <Box>{children}</Box>;
};

export default FeedbackFailed;
